import { RouteId } from './routes';

export const isCardRoute = (routeId: RouteId): boolean => {
  const routes = [RouteId.CARD, RouteId.CARD_OLD];

  return routes.some((route) => route === routeId);
};
